const BlogUpdatesSection = () => {
  return (
    <section className="flex h-screen items-center justify-center bg-cyan-900" data-cy="blog-updates-section">
      <div className="text-6xl text-white">BLOG</div>
    </section>
  );
};

export default BlogUpdatesSection;
